/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tableSort',
  standalone: false,
})
export class TableSortPipe<T> implements PipeTransform {
  transform(items: T[], direction: string, column: string, type: string): T[] {
    // make sure column isn't empty before sorting, else return items unsorted
    if (column != '') {
      const sortedItems = items.sort((a: T, b: T) => {
        const res = compare(
          (a as Record<string, unknown>)[column],
          (b as Record<string, unknown>)[column],
        );
        return direction === 'asc' ? res : -res;
      });

      return sortedItems;
    } else {
      return items;
    }

    // function to perform custom sort
    function compare(v1: unknown, v2: unknown) {
      if (type === 'number') {
        return Number(v1) - Number(v2);
      } else if (type === 'date') {
        const d1 =
          v1 instanceof Date
            ? v1.getTime()
            : typeof v1 === 'string' || typeof v1 === 'number'
              ? new Date(v1).getTime()
              : 0;
        const d2 =
          v2 instanceof Date
            ? v2.getTime()
            : typeof v2 === 'string' || typeof v2 === 'number'
              ? new Date(v2).getTime()
              : 0;
        return d1 - d2;
      } else if (type === 'array') {
        const a1 = Array.isArray(v1) ? v1.length : 0;
        const a2 = Array.isArray(v2) ? v2.length : 0;
        return a1 - a2;
      } else {
        // deal with null/empty values
        if (v1 == null || v1 == 'null') {
          return 1;
        } else if (v2 == null || v2 == 'null') {
          return -1;
        } else {
          return String(v1).localeCompare(String(v2));
        }
      }
    }
  }
}
